export default [
	{
		path: '/main/home/:type?',
		name: 'MainHome',
		component: () => import('@/views/main/home.vue'),
		meta: { title: 'main' }
	}
]
